import { useState, useEffect, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { fetchTotalMessagesUnreadCount } from '../services/messageCountsService';

/**
 * Total unread for Messages (YAU inbox + team chats), for sidebar badge.
 */
export function useMessagesSidebarBadge() {
  const { user } = useAuth();
  const location = useLocation();
  const [count, setCount] = useState(0);

  const refresh = useCallback(async () => {
    if (!user?.uid) {
      setCount(0);
      return;
    }
    try {
      const n = await fetchTotalMessagesUnreadCount(user);
      setCount(n);
    } catch {
      setCount(0);
    }
  }, [user]);

  useEffect(() => {
    refresh();
  }, [refresh, location.pathname]);

  useEffect(() => {
    const id = setInterval(refresh, 45000);
    return () => clearInterval(id);
  }, [refresh]);

  return count;
}
